<div class="player_container" *ngIf="hasReceivedVehicles">
  <!-- Playback Speed Dropdown -->
  <div class="playback-dropdown" *ngIf="showDropdown">
   <div class="playspeed" [ngClass]="{ active: playbackSpeed === 0.5 }" (click)="setPlaybackSpeed(0.5)">
      0.5
    </div>
    <div class="playspeed" [ngClass]="{ active: playbackSpeed === 1 }" (click)="setPlaybackSpeed(1)">
      Normal
    </div>
    <div class="playspeed" [ngClass]="{ active: playbackSpeed === 2 }" (click)="setPlaybackSpeed(2)">
      2x
    </div>
    <div class="playspeed" [ngClass]="{ active: playbackSpeed === 4 }" (click)="setPlaybackSpeed(4)">
      4x
    </div>
  </div>

  <!-- Time and Controls -->
  <div class="time-control-box">
    <div class="time-box" *ngIf="currentTimeDisplay">{{ currentTimeDisplay }}</div>
      <div class="timeline-legend">
    <div class="legend-item">
        <img [src]="imgConstants.TRIP_START">
      <span>Trip start</span>
    </div>
    <div class="legend-item">
      <img [src]="imgConstants.TRIP_END">
      <span>Trip end</span>
    </div>
        <div class="legend-item">
      <img [src]="imgConstants.SIGN_IN">
      <span>Sign In</span>
    </div>
     <div class="legend-item">
      <img [src]="imgConstants.SIGN_OUT">
      <span>Sign Out</span>
    </div>
  </div>
    <div class="player-controls">
      <button class="backward" style="background: url(assets/icons/fast_backward.svg);"
        (click)="skipBackward()"></button>
      <button class="pause" style="background: url(assets/icons/pause.svg);" *ngIf="!isPaused && currentTime !== globalTimeRange.max"
        (click)="togglePlayPause()"></button>
      <button class="play" style="background: url(assets/icons/play_arrow.svg);" *ngIf="isPaused && currentTime !== globalTimeRange.max"
        (click)="togglePlayPause()"></button>
      <button *ngIf="currentTime === globalTimeRange.max" class="forward" style="background: url(assets/icons/replay.svg)"
        (click)="replay()"></button>
      <button class="forward" style="background: url(assets/icons/fast_forward.svg)"
        (click)="skipForward()"></button>
      <span class="playback-speed" (click)="toggleDropdown()"
        [ngStyle]="{ 'background-color': showDropdown ? '#CFECF9' : '' }">
        {{ playbackSpeed }}x
        <img src="assets/icons/down-carrot.svg" alt="down-carrot" />
      </span>
    </div>
  </div>

  <!-- Employee Markers Toggle -->
  <div class="employee-toggle-container">
    <label class="toggle-label">
      <input type="checkbox" 
             [checked]="showEmployeeMarkers" 
             (change)="toggleEmployeeMarkers($event)" 
             class="toggle-checkbox" />
      <span class="toggle-text">Employee Sign-In/Out</span>
    </label>
  </div>


  <div style="overflow-x: auto; overflow-y: hidden;">
    <div class="progress_bar_container" [ngStyle]="{ width: zoom + '%' }">
      <div class="progress_bar">
        <!-- Trip Start/End Markers for all vehicles -->
        <div class="event-icon-box" *ngFor="let marker of tripMarkers" 
             [ngStyle]="{ 'left': marker.marginLeft + '%' }">
          <!-- Trip Start Icon -->
          <svg *ngIf="marker.type === 'TRIP_START'" width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.924 6.24422L16.0309 1.15746C16.2496 0.798244 16.1357 0.329729 15.7764 0.111056C15.6576 0.0387153 15.5212 0.0003159 15.3821 0H0.761494C0.340926 0 0 0.340926 0 0.761495V17.2097C0 17.6303 0.340926 17.9712 0.761494 17.9712C1.18206 17.9712 1.52299 17.6303 1.52299 17.2097V12.4885H15.3821C15.8027 12.4876 16.1429 12.1459 16.142 11.7253C16.1416 11.5862 16.1032 11.4498 16.0309 11.331L12.924 6.24422Z" [attr.fill]="marker.color"/>
          </svg>

          <!-- Trip End Icon -->
          <svg *ngIf="marker.type === 'TRIP_END'" width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5832 0C0.261099 0 0 0.261099 0 0.5832V18.8568C0 19.1789 0.261099 19.44 0.5832 19.44H1.5552C1.8773 19.44 2.1384 19.1789 2.1384 18.8568V0.5832C2.1384 0.261099 1.8773 0 1.5552 0H0.5832Z" [attr.fill]="marker.color"/>
            <path d="M3.49922 0C3.17711 0 2.91602 0.261099 2.91602 0.5832V4.4712H8.16482V0H3.49922Z" [attr.fill]="marker.color"/>
            <path d="M14.3856 4.4712V0.5832C14.3856 0.261099 14.1245 0 13.8024 0H8.94238V4.4712H14.3856Z" [attr.fill]="marker.color"/>
            <path d="M14.3856 5.24854H8.94238V9.71974H13.8024C14.1245 9.71974 14.3856 9.45864 14.3856 9.13654V5.24854Z" [attr.fill]="marker.color"/>
            <path d="M8.16482 5.24854H2.91602V9.13654C2.91602 9.45864 3.17711 9.71974 3.49922 9.71974H8.16482V5.24854Z" [attr.fill]="marker.color"/>
          </svg>
        </div>

        <!-- Employee Sign-In/Out Markers -->
        <div class="employee-marker-box" 
             *ngFor="let marker of employeeMarkers" 
             [ngStyle]="{ 'left': marker.marginLeft + '%' }"
             [hidden]="!showEmployeeMarkers"
             (mouseenter)="onEmployeeMarkerHover(marker, true)"
             (mouseleave)="onEmployeeMarkerHover(marker, false)">
          <!-- Sign-In Icon (Login direction) -->
          <svg *ngIf="marker.type === 'SIGN_IN'" width="47" height="57" viewBox="0 0 47 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g [attr.filter]="'url(#filter0_d_signin_' + marker.vehicleId + ')'">
              <path fill-rule="evenodd" clip-rule="evenodd" 
                    d="M23.3335 7.33325C28.8474 7.33325 33.3334 11.8192 33.3334 17.3334C33.3334 20.2608 32.7827 21.5833 30.1604 24.7118C26.8585 28.651 23.8333 34.0508 23.8333 36.8333C23.8333 37.1093 23.6094 37.3333 23.3333 37.3333C23.0573 37.3333 22.8334 37.1093 22.8334 36.8333C22.8334 34.0508 19.8593 28.4466 16.4998 24.7059C14.7058 22.7083 13.3334 20.2609 13.3334 17.3334C13.3334 11.8193 17.8194 7.33325 23.3335 7.33325Z" 
                    [attr.fill]="marker.color"/>
              <path d="M23.3334 6.66626C17.4512 6.6663 12.6665 11.4511 12.6664 17.3333C12.6664 20.4834 14.1467 23.0833 16.0043 25.1516C17.6433 26.9768 19.196 29.2663 20.3363 31.4387C21.4924 33.6411 22.1664 35.6147 22.1664 36.8333C22.1664 37.4774 22.6892 38.0002 23.3334 38.0002C23.9776 38.0002 24.5004 37.4774 24.5004 36.8333C24.5004 35.6197 25.1832 33.7002 26.347 31.5198C27.4937 29.3717 29.0491 27.0752 30.6713 25.1399C31.9885 23.5684 32.8367 22.3926 33.3431 21.2092C33.8583 20.0053 34.0004 18.8417 34.0004 17.3333C34.0003 11.4509 29.2155 6.66626 23.3334 6.66626Z" 
                    [attr.stroke]="marker.color" stroke-width="1.33333"/>
            </g>
            <path d="M26.2083 24.9831H20.3583C20.0997 24.9831 19.8517 24.8755 19.6689 24.6839C19.486 24.4924 19.3833 24.2326 19.3833 23.9617V22.4295H20.3583V23.9617H26.2083V11.7045H20.3583V13.2367H19.3833V11.7045C19.3833 11.4336 19.486 11.1738 19.6689 10.9823C19.8517 10.7907 20.0997 10.6831 20.3583 10.6831H26.2083C26.4669 10.6831 26.7149 10.7907 26.8977 10.9823C27.0806 11.1738 27.1833 11.4336 27.1833 11.7045V23.9617C27.1833 24.2326 27.0806 24.4924 26.8977 24.6839C26.7149 24.8755 26.4669 24.9831 26.2083 24.9831Z" fill="white"/>
            <path d="M20.4547 19.7459L22.1353 17.9958H15.4833V17.0208H22.1353L20.4547 15.2706L21.1166 14.5833L23.9333 17.5083L21.1166 20.4333L20.4547 19.7459Z" fill="white"/>
            <defs>
              <filter [attr.id]="'filter0_d_signin_' + marker.vehicleId" x="0" y="0" width="46.6667" height="56.6665" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="6"/>
                <feGaussianBlur stdDeviation="6"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.14902 0 0 0 0.1 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4512_28988"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4512_28988" result="shape"/>
              </filter>
            </defs>
          </svg>
          
          <!-- Sign-Out Icon (Logout direction) -->
          <svg *ngIf="marker.type === 'SIGN_OUT'" width="47" height="57" viewBox="0 0 47 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g [attr.filter]="'url(#filter0_d_signout_' + marker.vehicleId + ')'">
              <path fill-rule="evenodd" clip-rule="evenodd" 
                    d="M23.3335 7.33325C28.8474 7.33325 33.3334 11.8192 33.3334 17.3334C33.3334 20.2608 32.7827 21.5833 30.1604 24.7118C26.8585 28.651 23.8333 34.0508 23.8333 36.8333C23.8333 37.1093 23.6094 37.3333 23.3333 37.3333C23.0573 37.3333 22.8334 37.1093 22.8334 36.8333C22.8334 34.0508 19.8593 28.4466 16.4998 24.7059C14.7058 22.7083 13.3334 20.2609 13.3334 17.3334C13.3334 11.8193 17.8194 7.33325 23.3335 7.33325Z" 
                    [attr.fill]="marker.color"/>
              <path d="M23.3334 6.66626C17.4512 6.6663 12.6665 11.4511 12.6664 17.3333C12.6664 20.4834 14.1467 23.0833 16.0043 25.1516C17.6433 26.9768 19.196 29.2663 20.3363 31.4387C21.4924 33.6411 22.1664 35.6147 22.1664 36.8333C22.1664 37.4774 22.6892 38.0002 23.3334 38.0002C23.9776 38.0002 24.5004 37.4774 24.5004 36.8333C24.5004 35.6197 25.1832 33.7002 26.347 31.5198C27.4937 29.3717 29.0491 27.0752 30.6713 25.1399C31.9885 23.5684 32.8367 22.3926 33.3431 21.2092C33.8583 20.0053 34.0004 18.8417 34.0004 17.3333C34.0003 11.4509 29.2155 6.66626 23.3334 6.66626Z" 
                    [attr.stroke]="marker.color" stroke-width="1.33333"/>
            </g>
            <path d="M26.2083 24.9831H20.3583C20.0997 24.9831 19.8517 24.8755 19.6689 24.6839C19.486 24.4924 19.3833 24.2326 19.3833 23.9617V22.4295H20.3583V23.9617H26.2083V11.7045H20.3583V13.2367H19.3833V11.7045C19.3833 11.4336 19.486 11.1738 19.6689 10.9823C19.8517 10.7907 20.0997 10.6831 20.3583 10.6831H26.2083C26.4669 10.6831 26.7149 10.7907 26.8977 10.9823C27.0806 11.1738 27.1833 11.4336 27.1833 11.7045V23.9617C27.1833 24.2326 27.0806 24.4924 26.8977 24.6839C26.7149 24.8755 26.4669 24.9831 26.2083 24.9831Z" fill="white"/>
            <path d="M31.5453 19.7459L29.8647 17.9958H36.5167V17.0208H29.8647L31.5453 15.2706L30.8834 14.5833L28.0667 17.5083L30.8834 20.4333L31.5453 19.7459Z" fill="white"/>
            <defs>
              <filter [attr.id]="'filter0_d_signout_' + marker.vehicleId" x="0" y="0" width="46.6667" height="56.6665" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="6"/>
                <feGaussianBlur stdDeviation="6"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.14902 0 0 0 0.1 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4512_28988"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4512_28988" result="shape"/>
              </filter>
            </defs>
          </svg>
          
          <!-- Hover count display -->
          <span class="employee-hover-count" *ngIf="marker.showCount">
            +{{ marker.employeeCount }}
          </span>
        </div>

        <!-- Single Unified Range Slider -->
        <input #ranger type="range" 
               [min]="globalTimeRange.min" 
               [max]="globalTimeRange.max"
               [step]="1000" 
               [value]="currentTime"
               [style.--progress]="progress + '%'"
               (input)="onTimelineChange($event)" 
               (mousedown)="handleMouseDown()"
               (mouseup)="handleMouseUp()" />
      </div>

      <!-- Time Stamps -->
      <div class="time-stamps">
        <div *ngFor="let timestamp of timestamps; let i = index" 
             [ngStyle]="{ 'left': (i * 10) + '%' }">
          <div class="stroke"></div>
          <span class="timestamp-value">{{ timestamp }}</span>
          
        </div>
      </div>

      <!-- Start/End Labels -->
      <div class="start-end-text-box">
        <div>Start</div>
        <div>End</div>
      </div>

      <!-- Zoom Controls -->
      <div class="zoom-box">
        <img src="assets/icons/zoom_out.svg" alt="zoom_out" (click)="zoomOut()" style="cursor: pointer;" />
        <input #zoomer id="zoomer" type="range" [min]="100" [max]="500" [step]="100" [value]="zoom"
          (input)="handleZoom(zoomer.value)" />
        <img src="assets/icons/zoom_in.svg" alt="zoom_in" (click)="zoomIn()" style="cursor: pointer;" />
      </div>
    </div>
  </div>
</div>

<div class="empty-state" *ngIf="!hasReceivedVehicles">
  <p>Select vehicles from the sidebar to start replay</p>
</div>
